import React from "react";
import { RCCButton, RCCGrid, RCCPopover,  RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import SortableHandle from "src/components/Sortable/Handle";
import formatNumber from "src/utils/formatNumber";
import CheckPermission from "src/components/CheckPermission";
import { PermissionEnum } from "src/context/Auth/interface";
import { useAuth } from "src/context/Auth/context";
import { IMetba002 } from "./interface";
import { PerspectiveCard } from "./styles";
import ObjectivesList from "../Objectives";
import BadgeAssociate from "../Badge/badgeAssociate";
import { useMap } from "../MapsContextProvider";

export interface IPerspestive{
    perspective: IMetba002;
}

const Perspective: React.FC<IPerspestive> = ({
	perspective
}) => {
	const { translate , currentLanguage } = useTranslation();
	const { administrator, superUser } = useAuth();
	
	const { mapId, permissions, inEditCauseEffect, updatingPercentage,
		onCallbackDeletePerspective, openModalPerspective, openModalObjective 
	} = useMap();

	return (
		<PerspectiveCard 
			color={perspective.mea002Cor}
			inEditCauseEffect={inEditCauseEffect}
		>
			<div className="card-options">
				<RCCPopover
					header={{
					  	title: translate("Descrição da perspectiva")
					}}
					body={{
					  	text: perspective.mea002Descricao
					}}
					position="rightEnd"
				>
					<RCCButton
						icon={{
							name: "info",
							color: "#FFF", 
							size: 12
						}}
						layout="isRounded"
						size="xs"
					/>
				</RCCPopover>
				<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
					{( permissions >= 2 || administrator || superUser) && (
						<>
							<SortableHandle>
								<RCCTooltip 
									text={translate("Mover Perspectiva")}
								>
									<RCCButton
										icon={{
											name: "arrows", 
											color: "#FFF", 
											size: 14
										}}
										layout="isRounded"
										size="xs"
									/>
								</RCCTooltip>	
							</SortableHandle>
							<RCCTooltip 
								text={translate("Adicionar Objetivo")}
							>
								<RCCButton
									icon={{
										name: "plus", 
										color: "#FFF", 
										size: 14
									}}
									layout="isRounded"
									size="xs"
									onClick={() => {if(!openModalObjective) return; openModalObjective(perspective);}}
								/>
							</RCCTooltip>
							<RCCTooltip 
								text={translate("Editar Perspectiva")}
							>
								<RCCButton
									icon={{
										name: "pencil", 
										color: "#FFF", 
										size: 14
									}}
									layout="isRounded"
									size="xs"
									onClick={() => {if(!openModalPerspective) return; openModalPerspective(perspective);}}
								/>
							</RCCTooltip>
						</>
					)}											
				</CheckPermission>
				<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE_DELETE}>
					{( permissions >= 2 || administrator || superUser) && (
						<>
							<RCCTooltip
								text={translate("Excluir Perspectiva")}
							>
								<RCCButton
									icon={{
										name: "trash", 
										color: "#FFF", 
										size: 14
									}}
									layout="isRounded"
									size="xs"
									onClick={() => onCallbackDeletePerspective(perspective.mea002Id, perspective.mea002Nome)}
								/>
							</RCCTooltip>
						</>
					)}											
				</CheckPermission>
			</div>
			<div>
				<RCCGrid 
					className="card-header"
				>
					<RCCGrid
						container
						item
						xs={6}
					> 
						<span>
							{perspective.mea002Nome}	
						</span>
					</RCCGrid>
					<RCCGrid 
						container 
						item
						xs={6}
						justifyContent="flex-end"
						styleInline="display: contents !important"
					>
						{
							!updatingPercentage ? 
								<>
									<BadgeAssociate
										mapId={mapId}
										perspectiveId={perspective.mea002Id}
										associations={perspective.associations}
										position="right"
										label="word"										
									/>
									<RCCGrid>
										<span>
											{formatNumber(perspective.realizedPercentage ?? 0, currentLanguage, 2)}%
										</span>
									</RCCGrid>
								</>
								: <span>{translate("Atualizando...")}</span>
						}
						
					</RCCGrid>
				</RCCGrid>
				<div className="card-body">
					<ObjectivesList
						perspective={perspective} 
						objectives={perspective.metba003 || []} 
					/>
				</div>
			</div>
		</PerspectiveCard>
	);
};

export default Perspective;
